module.exports = __webpack_public_path__ + "media/application/images/customers/sweet-backflip-34b6990297297004a1a5e44039867b5d.jpg";